export default "__VITE_ASSET__$prUn2dS__"